import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePackageInsuranceMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  id: GraphQLTypes.Scalars['String'];
  packageInsuranceInput: GraphQLTypes.UpdateInsurancePackageInput;
}>;


export type UpdatePackageInsuranceMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'updatePackageInsurance'>
);


export const UpdatePackageInsuranceDocument = /*#__PURE__*/ gql`
    mutation updatePackageInsurance($packageId: String!, $id: String!, $packageInsuranceInput: UpdateInsurancePackageInput!) {
  updatePackageInsurance(
    packageId: $packageId
    id: $id
    packageInsuranceInput: $packageInsuranceInput
  )
}
    `;

/**
 * __useUpdatePackageInsuranceMutation__
 *
 * To run a mutation, you first call `useUpdatePackageInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageInsuranceMutation, { data, loading, error }] = useUpdatePackageInsuranceMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      id: // value for 'id'
 *      packageInsuranceInput: // value for 'packageInsuranceInput'
 *   },
 * });
 */
export function useUpdatePackageInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageInsuranceMutationResult, UpdatePackageInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageInsuranceMutationResult, UpdatePackageInsuranceMutationVariables>(UpdatePackageInsuranceDocument, options);
      }
export type UpdatePackageInsuranceMutationHookResult = ReturnType<typeof useUpdatePackageInsuranceMutation>;